import {Howl} from 'howler';

const audioPlayer = () => {
    const players = document.querySelectorAll('.player_audio');

    const runPlayer = (player) => {
        const audio = player.dataset.src;
        const play = player.querySelector('[data-play]');
        const progressBar = player.querySelector('[data-progress]');
        const durationBox = player.querySelector('[data-duration]');
        const seekBox = player.querySelector('[data-seek]');
        let running;

        const formatTime = (secs) => {
            const minutes = Math.floor(secs / 60) || 0;
            const seconds = (secs - minutes * 60) || 0;

            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        };

        const runTimer = () => {
            running = setInterval(() => {
                seekBox.textContent = formatTime(Math.round(sound.seek()));
            }, 1000);

            running = setInterval(() => {
                progressBar.style.width = (((sound.seek() / sound.duration()) * 100) || 0) + '%';
            }, 100);
        }

        const pauseTimer = () => {
            clearInterval(running);
        }

        const sound = new Howl({
            src: [audio],
            html5: true,
            onload() {
                durationBox.textContent = formatTime(Math.round(sound.duration()));
            },
            onend() {
                pauseTimer();
                player.classList.remove('is-playing');
                seekBox.textContent = '0:00';
                progressBar.style.width = '0%';
                sound.stop();
            }
        });

        play.onclick = () => {
            if (sound.playing()) {
                player.classList.remove('is-playing');
                sound.pause()

                pauseTimer();
            } else {
                player.classList.add('is-playing');
                sound.play()

                runTimer();
            }
        };

        player.onclick = e => {
            if (e.target == player) {
                const percent = Math.round((e.offsetX * 100)/player.offsetWidth);
                const seconds = Math.round(sound.duration() * (percent/100));

                sound.seek([seconds]);
            }
        };

        player.onmousemove = e => {
            if (e.target == player) {
                const percent = Math.round((e.offsetX * 100)/player.offsetWidth);
                const seconds = Math.round(sound.duration() * (percent/100));

                player.setAttribute('title', formatTime(seconds));
            }
        };

        player.onmouseleave = e => {
            player.removeAttribute('title');
        }
    }

    for (const player of players) {
        runPlayer(player);
    }
}

export default audioPlayer;


// WEBPACK FOOTER //
// ./assets/js/partials/audio_player.js